import { getBranchId, getHospitalId, getLoginID } from "../../../auth";
import FetchData from "../../client";

export const FetchPharmacyTransferReport = async (inputData) => {
  try {
    inputData.doctorid = getLoginID();
    // inputData.branchid = getBranchId();
    inputData.hospitalid = getHospitalId();
    const result = await FetchData(
      "midoc_getpharmacytransferreport",
      inputData
    );
    // console.log(result, "Medicine View Result");
    if (result.output) {
      // var finalOutput = formapimodalmedicinesPagination(result.output)
      // console.log(finalOutput, "finalOUTPUT");
      return result.output;
    }
  } catch (error) {
    console.error("Error fetching data in forms.js:", error);
    throw error;
  }
};
